import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeAll24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEdgeAll24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 4.406a.75.75 0 0 0 0-1.5H7a.75.75 0 1 0 0 1.5zM4.402 7a.75.75 0 1 0-1.5 0v10a.75.75 0 1 0 1.5 0zm16.689 0a.75.75 0 0 0-1.5 0v10a.75.75 0 1 0 1.5 0zM17.75 20.344a.75.75 0 0 1-.75.75H7a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeAll24);
